// Utilities to parse and calculate totals from South African Rand price strings
// Supports formats:
// - "R100"
// - "R 100"
// - "3 for R100"
// - "3 for R 100"
// Returns amounts in cents to avoid floating point issues

export function parsePriceText(priceTextRaw) {
  if (!priceTextRaw) {
    return { currency: "R", type: "unknown", unitPriceCents: 0, original: "" };
  }
  const text = String(priceTextRaw).trim();

  // Normalized currency
  const currency = "R";

  // Pattern: 3 for R100
  const multiMatch = text.match(/^(\d+)\s*for\s*R\s*(\d+(?:[.,]\d{1,2})?)$/i);
  if (multiMatch) {
    const packSize = parseInt(multiMatch[1], 10);
    const packPrice = multiMatch[2].replace(",", ".");
    const packPriceCents = Math.round(parseFloat(packPrice || "0") * 100);
    const unitPriceCents = packSize > 0 ? Math.round(packPriceCents / packSize) : 0;
    return {
      currency,
      type: "multi",
      packSize,
      packPriceCents,
      unitPriceCents,
      original: text,
    };
  }

  // Pattern: R100 or R 100
  const unitMatch = text.match(/^R\s*(\d+(?:[.,]\d{1,2})?)$/i);
  if (unitMatch) {
    const unit = unitMatch[1].replace(",", ".");
    const unitPriceCents = Math.round(parseFloat(unit || "0") * 100);
    return {
      currency,
      type: "unit",
      unitPriceCents,
      original: text,
    };
  }

  // Fallback: try to extract last number as price after R
  const looseMatch = text.match(/R\s*(\d+(?:[.,]\d{1,2})?)/i);
  if (looseMatch) {
    const val = looseMatch[1].replace(",", ".");
    const unitPriceCents = Math.round(parseFloat(val || "0") * 100);
    return { currency, type: "unit", unitPriceCents, original: text };
  }

  return { currency, type: "unknown", unitPriceCents: 0, original: text };
}

export function calculateItemTotalCents(priceMeta, quantity) {
  const qty = Math.max(0, parseInt(quantity || 0, 10));
  if (!priceMeta) return 0;

  if (priceMeta.type === "multi" && priceMeta.packSize > 0) {
    const packs = Math.floor(qty / priceMeta.packSize);
    const remainder = qty % priceMeta.packSize;
    // Allow any quantity: charge full packs at pack price + remainder at unit price
    return packs * priceMeta.packPriceCents + remainder * priceMeta.unitPriceCents;
  }
  // Unit pricing
  return qty * (priceMeta.unitPriceCents || 0);
}

export function formatRandFromCents(cents) {
  const value = (cents || 0) / 100;
  // Ensure dot as decimal separator and no trailing zeros when not needed
  return `R${value.toFixed(2).replace(/\.00$/, "")}`;
}
